import { useMemo } from 'react';
import { ObjectProfessionEntityFragment } from 'pages/facilityCasings/api/fragments/generated/ObjectProfessionEntity.fragment';

export type IFacilityCasings = {
  id?: string;
  name?: string;
  isMedBookRequired: boolean;
  object: {
    id: string;
  };
};

const useFacilityCasingsPositions = (
  facilityCasings?: ObjectProfessionEntityFragment[],
): IFacilityCasings[] | undefined => {
  return useMemo(
    () =>
      facilityCasings?.map(el => ({
        id: el.id,
        name: el.hrmsProfession?.name,
        object: { id: el.object?.id || '' },
        isMedBookRequired: el.isMedBookRequired,
      })),
    [facilityCasings],
  );
};

export default useFacilityCasingsPositions;
